import {Outlet, useLocation} from 'react-router';
import {motion} from 'framer-motion';
import useHelmet from 'utilities/hooks/helmet/useHelmet';
const AuthLayout = () => {
  const {pathname} = useLocation();
  useHelmet('ورود به حساب کاربری');

  return (
    <>
      <motion.div
        key={pathname}
        initial={{opacity: 0, x: '100%'}}
        animate={{opacity: 1, x: 0}}
        exit={{opacity: 0, x: '-100%'}}
        transition={{duration: 0.2}}
        className="w-full h-full theme-mazrae flex justify-center items-center"
        style={{overflow: 'hidden'}}
      >
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </motion.div>
    </>
  );
};

export default AuthLayout;
